/**
 * Generates a Jira issue search URL with JQL query
 *
 * @param {string} domain - The Jira domain (e.g., "your-company")
 * @param {string} projectKey - Optional project key to filter by
 * @param {Array<{title: string}>} tasks - Optional array of tasks to include specific issue keys in the search
 * @returns {string} Complete Jira search URL
 */
const generateJiraSearchUrl = (domain: string, projectKey?: string, tasks?: { title: string }[]): string => {
  let jql = '';

  if (tasks && tasks.length > 0) {
    // Filter out any empty/invalid titles and build the key list
    const issueKeys = tasks
      .map((task) => task.title)
      .filter((title) => title && title.trim().length > 0)
      .map((title) => `"${title}"`)
      .join(', ');

    if (issueKeys.length > 0) {
      jql = `key in (${issueKeys})`;

      // Add project filter if provided and we have issue keys
      if (projectKey) {
        jql += ` AND project = "${projectKey}"`;
      }
    } else if (projectKey) {
      // Fallback to project filter if no valid issue keys
      jql = `project = "${projectKey}"`;
    }
  } else if (projectKey) {
    // Original behavior when no tasks are provided
    jql = `project = "${projectKey}"`;
  }

  // If no valid JQL was built, return a basic search URL
  if (!jql) {
    return `${domain}issues/`;
  }

  const encodedJql = encodeURIComponent(jql);
  return `${domain}issues/?jql=${encodedJql}`;
};

export { generateJiraSearchUrl };
